import { Button, Grid, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import ImageProfileCircle from "../../components/ImageProfileCircle";
import { useEffect, useState } from "react";
import { getEmployeesAnniversary, getEmployeesBithdays } from "../../api/signalApi";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

import { BirthdayData } from "../../interfaces/birthDay.interface";
const topImage = require('../../assets/images/posts/birthday.svg').default;


interface BirthdaysCardProps {
    title: string;
    hidenButton?: boolean;
    month?: number;
    onlyList?: boolean;
}

export const BirthdayEmployeeCard = ({data}: any) => {

    const {s10palette} = useTheme();
    
    const formatTextToTitleFormat = (text: string): string => {
        const nameSplited = text.split(" ");
        let finalName = "";
        for (let i = 0; i < nameSplited.length; i++) {
            const element = nameSplited[i];
            const primeraLetra = element.charAt(0).toUpperCase();
            const restoDelTexto = element.slice(1).toLowerCase();
            finalName += primeraLetra + restoDelTexto + " ";
            
        }
        
        return finalName
    }

    const formatBirthdayDate = (fechaString: string) => {
        const fecha = new Date(fechaString);
        fecha.setFullYear(new Date().getFullYear());
        const daysNames = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
        const diaSemana = daysNames[fecha.getDay()];
        const dia = fecha.getDate();
        const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        const mes = monthNames[fecha.getMonth()];

        return `${diaSemana} ${dia} de ${mes}`;
    }

    return (
        
        <Grid container item style={{width: "100%"}} direction={"row"}>
            <ImageProfileCircle 
                width="2.5rem"
                height="2.5rem"
                ruc={data.RUCEmpresa}
                userId={data.CodIdentificador}
                userName={data.Descripcion}
            />
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                item 
                style={{
                    flex: 1,
                    width: "100%",
                    marginLeft: ".5rem"
                }}
            >
                <Typography variant="subtitle2" color={s10palette.S10Greygrey700}>
                    {formatTextToTitleFormat(`${data.Nombres} ${data.ApellidoPaterno}`)}
                </Typography>
                <Typography variant="subtitle1" fontSize={"0.75rem"} color={s10palette.S10Greygrey500}>
                    {formatBirthdayDate(data.Aniversario)}
                </Typography>
                <Typography variant="subtitle1" fontSize={"0.75rem"} color={s10palette.S10Greygrey500}>
                    {data.DescripcionAniversario}
                </Typography>
            </Grid>
        </Grid>
    )
}

const BirthdaysCard = ({title, hidenButton, month=0, onlyList}: BirthdaysCardProps) => {
    // const navigate = useNavigate();
    // const {s10palette} = useTheme();
    const {companyselected, sessionData, connectionId} = useSelector((state: RootState) => state.auth);
    const {birthdaysData, birthdaysDataCurrent, anniversariesData} = useSelector((state: RootState) => state.posts);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredBirtdays, setFilteredBirtdays] = useState<any[]>([]);
    const [currentPageAnniversary, setCurrentPageAnniversary] = useState(1);
    const [tabSelected, setTabSelected] = useState(0);

    const tabOptions = [{name: "Cumpleaños"}, {name: "Aniversarios"}]

    const getMonthData = async () => {
        if (onlyList) {
            let monthToGet = new Date().getMonth() + 1;
            let promises = [];
            for (let i = 0; i < 12; i++) {
                promises.push(getEmployeesBithdays(monthToGet));
                monthToGet = monthToGet >= 12 ? 0 : monthToGet + 1;
            }
            await Promise.all(promises);
        } else {
            await getEmployeesBithdays(month, currentPage);
        }
        setIsLoading(false)
    }
    
    const getAnniversaryData = async () => {
        if (onlyList) {
            return
        }
        await getEmployeesAnniversary(currentPageAnniversary);
        setIsLoading(false)
    }

    useEffect(() => {
        if (!companyselected || !sessionData || !connectionId || isLoading) return;
        setIsLoading(true);
        getMonthData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId, month, currentPage]);

    useEffect(() => {
        if (!companyselected || !sessionData || !connectionId || isLoading) return;
        setIsLoading(true);
        getAnniversaryData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId, month, currentPageAnniversary]);

    useEffect(() => {
        if (birthdaysData?.data?.length && month !== 0) {
            if (onlyList) {
                let orderedData: BirthdayData[] = [];
                const data = birthdaysData?.data;
                let monthToGet = new Date().getMonth();
                for (let i = 0; i < 12; i++) {
                    const mothData = data
                                    // eslint-disable-next-line no-loop-func
                                    .filter(b => (new Date(b.Aniversario).getMonth()) === monthToGet)
                                    .sort((a, b) => new Date(a.Aniversario).getDate() - new Date(b.Aniversario).getDate());
                    orderedData = [...orderedData, ...mothData];
                    monthToGet = monthToGet >= 12 ? 0 : monthToGet + 1;
                }
                setFilteredBirtdays(orderedData);
            } else if (month === 0) {
                setFilteredBirtdays(birthdaysDataCurrent?.data || []);
            } else {
                const selectedMonth = month ? month - 1 : new Date().getMonth();
                setFilteredBirtdays(birthdaysData?.data
                    ?.filter(b => (new Date(b.Aniversario).getMonth()) === selectedMonth)
                );
            }
        }
        if (birthdaysDataCurrent?.data?.length && month === 0) {
            setFilteredBirtdays(birthdaysDataCurrent?.data || []);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [birthdaysData, birthdaysDataCurrent, month]);

    return (<Paper 
        elevation={3}
        style={{
            width: "100%", 
            borderRadius: "0.5rem",
        }}
    >
        {!onlyList && <Grid item style={{width: "100%", borderRadius: "0.5rem",}}>
            <img 
                style={{
                    width: "100%",
                }}
                src={topImage} 
                alt="quick access"
            />
        </Grid>}
        <Grid style={{padding: `${onlyList ? ".5" : "0"}rem 1rem 1rem 1rem`, width: "100%"}}>
            {onlyList 
                ? 
                (<Grid item>
                    <Typography variant="h6" style={{marginTop: "1rem"}}>
                        {tabSelected === 0 ? title : tabOptions[tabSelected].name}
                    </Typography>
                </Grid>)
                :
                (
                    <Tabs
                        value={tabSelected}
                        onChange={(_, tab) => setTabSelected(tab)}
                        centered
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {tabOptions.map((tab, i) => (
                            <Tab key={i} style={{padding: '10px'}} label={tab.name}/>
                        ))}
                    </Tabs>
                )
            }
            {tabSelected === 0 && filteredBirtdays
                .map((data, i) => (
                    <Grid
                        key={i}
                        style={{marginTop: "1rem"}}
                    >
                        <BirthdayEmployeeCard data={data} />
                    </Grid>
                ))
            }
            {tabSelected === 1 && anniversariesData?.data?.map((data, i) => (
                    <Grid
                        key={`${data.CodIdentificador}`}
                        style={{marginTop: "1rem"}}
                    >
                        <BirthdayEmployeeCard data={data} />
                    </Grid>
                ))
            }
            {hidenButton !== true && <Grid item style={{width: "100%", marginTop: "1.5rem"}}>
                {
                    ((tabSelected === 0 && !birthdaysDataCurrent?.isAllData) || 
                    (tabSelected === 1 && !anniversariesData?.isAllData)) 
                    && <Button 
                    fullWidth 
                    variant="contained"
                    style={{
                        height: "2.5rem",
                        // backgroundColor: s10palette.S10Blueblue50,
                        // color: s10palette.S10Blueblue600,
                        fontSize: "0.875rem",
                        padding: "1rem"
                    }}
                    disabled={isLoading}
                    disableElevation
                    // onClick={() => navigate('/general/cumpleanos')}
                    onClick={() => {
                        if (tabSelected === 0) {
                            setCurrentPage(currentPage + 1);
                        } else {
                            setCurrentPageAnniversary(currentPageAnniversary + 1);
                        }
                    }}
                >
                    {isLoading ? "Cargando..." : "Ver más"}
                </Button>}
            </Grid>}
        </Grid>
    </Paper>)
}

export default BirthdaysCard;